/**
 * Returns true if it's currently between 01:00 and 10:00 in Sydney/Australia,
 * regardless of the visitor's own timezone. Uses Intl.DateTimeFormat.
 */
export function isAfterHoursSydney(now = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-AU", {
      timeZone: "Australia/Sydney",
      hour: "numeric",
      hour12: false,
    }).formatToParts(now);
    const h = parseInt(parts.find((p) => p.type === "hour")?.value || "0", 10);
    return h >= 1 && h < 10;
  } catch {
    return false;
  }
}

/**
 * Decides whether to show OnlyFans-mode CTAs. Requires:
 *  - after_hours_mode toggle on in admin settings, AND
 *  - current Sydney hour in the [1, 10) window.
 * Admin can force via ?afterhours=1 URL param for testing.
 */
export function shouldShowAfterHours(afterHoursMode) {
  if (typeof window !== "undefined") {
    const q = new URLSearchParams(window.location.search);
    if (q.get("afterhours") === "1") return true;
  }
  return !!afterHoursMode && isAfterHoursSydney();
}
